// extracted by mini-css-extract-plugin
export default {"header":"UserList_header__7dDHh","title":"UserList_title__38FIN","formContainer":"UserList_formContainer__kXhNt","createAccountInputField":"UserList_createAccountInputField__Lzyjm"};